import Request from 'ui/Element/List/Item/Cell/Request/Information'
import Organisation from 'ui/Element/List/Item/Cell/Organisation/Information'
import Person from 'ui/Element/List/Item/Cell/Person/Information'
import ServiceItem from 'ui/Element/List/Item/Cell/ServiceItem/Information'

/**
 * Displays the appropriate list item based on the incoming `type`.
 *
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellRecentInformation = (props) => {
  const { meta: { type } } = props

  return (
    <>
      {type === 'serviceitem' && (<ServiceItem {...props} />)}
      {type === 'request' && (
        <Request
          {...props}
          withStatus={false}
          withDescription={false}
          withDevice={false}
        />
      )}
      {type === 'organisation' && (<Organisation {...props} />)}
      {type === 'person' && (<Person {...props} />)}
    </>
  )
}

export default ListItemCellRecentInformation
